module.exports = __webpack_public_path__ + "img/makeup_t.985677c6.png";